import React from "react";

export const ResendConfirmation = () => {
  return <div>Token incorrect or expired, send again</div>;
};
